const MATEY_HATS = [
  {
    slug: "matey-black-26",
    name: "Matey",
    description: "Part of the ship, part of the crew!",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "blackColor",
        value: 5
      },
      {
        stat: "blackRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_black",
      frameIndex: 26
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "matey-blue-26",
    name: "Matey",
    description: "Part of the ship, part of the crew!",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 26
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "matey-green-26",
    name: "Matey",
    description: "Part of the ship, part of the crew!",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 26
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "matey-orange-26",
    name: "Matey",
    description: "Part of the ship, part of the crew!",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 26
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "matey-pink-26",
    name: "Matey",
    description: "Part of the ship, part of the crew!",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 26
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "matey-purple-26",
    name: "Matey",
    description: "Part of the ship!",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_purple",
      frameIndex: 26
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "matey-red-26",
    name: "Matey",
    description: "Part of the ship, part of the crew!",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "redRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 26
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "matey-yellow-26",
    name: "Matey",
    description: "Part of the ship, part of the crew!",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "goldColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_yellow",
      frameIndex: 26
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  }
];
export {
  MATEY_HATS
};
//# sourceMappingURL=data:application/json;base64,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
